import Reveal from "@/components/Reveal";
import MeditationLibrary from "@/components/MeditationLibrary";

const CHAPTERS = [
  { n: "01", title: "SLOW DOWN", text: "Step out of the noise. Stillness is not empty — it is where the signal lives." },
  { n: "02", title: "REFLECT", text: "Turn your attention inward. Ask the questions you've been avoiding." },
  { n: "03", title: "HEAL", text: "Meet what you find with compassion. Old energy loosens when it is finally seen." },
  { n: "04", title: "RECONNECT", text: "Return to the part of yourself that already knows the way. It has been waiting." },
];

export default function InnerWork() {
  return (
    <section id="inner-work" data-testid="inner-work-section" className="relative px-5 py-24 sm:px-8 sm:py-32">
      <div className="mx-auto max-w-6xl">
        <div className="grid gap-14 lg:grid-cols-[1fr_1.2fr] lg:gap-20">
          <Reveal>
            <p className="eyebrow mb-5" data-testid="inner-work-eyebrow">The Practice</p>
            <h2
              data-testid="inner-work-heading"
              className="font-display text-3xl font-bold uppercase leading-tight tracking-[0.12em] text-slate-100 sm:text-4xl"
            >
              Inner Work Is The <span className="text-glow-cyan text-cyan-300">Real Work</span>
            </h2>
            <p className="mt-7 max-w-md text-sm leading-relaxed text-slate-400 sm:text-base" data-testid="inner-work-body">
              Everything The Shift offers begins here — in the quiet, honest space where you
              meet yourself. No shortcuts, no performance. Just presence, repetition, and the
              willingness to look within.
            </p>
          </Reveal>

          <div className="flex flex-col gap-4">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.1}>
                <div
                  data-testid={`inner-work-chapter-${c.n}`}
                  className="group flex items-baseline gap-6 border-b border-white/8 pb-5 transition-colors duration-500 hover:border-cyan-300/30"
                >
                  <span className="font-display text-sm tracking-[0.3em] text-violet-300/70 transition-colors duration-500 group-hover:text-cyan-300">
                    {c.n}
                  </span>
                  <div>
                    <h3 className="font-display text-base font-bold tracking-[0.25em] text-slate-100 sm:text-lg">
                      {c.title}
                    </h3>
                    <p className="mt-2 max-w-lg text-sm leading-relaxed text-slate-400">{c.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <MeditationLibrary />
      </div>
    </section>
  );
}
